module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "modal-regime-decision-entree el-dialog-header-blue",
    attrs: {
      "visible": _vm.visible,
      "width": "640px",
      "top": "0",
      "data-testid": "modal-regime-decision-entree"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "closed": _vm.onDialogClosed
    }
  }, [_c('div', {
    staticClass: "modal-header-custom",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', {
    staticClass: "modal-title",
    attrs: {
      "data-testid": "modal-regime-decision-entree-title"
    }
  }, [_vm._v("Aide au choix du régime maladie / retraite")])]), _vm._v(" "), (_vm.currentNode && _vm.currentNode.type === 'question') ? [_c('p', {
    staticClass: "question-text",
    attrs: {
      "data-testid": "modal-regime-decision-entree-question"
    }
  }, [_vm._v(_vm._s(_vm.currentNode.text))]), _vm._v(" "), _c('div', {
    staticClass: "answers-stack"
  }, _vm._l((_vm.currentNode.answers), function(answer) {
    return _c('el-button', {
      key: answer.nextId,
      staticClass: "answer-option-btn",
      attrs: {
        "plain": "",
        "data-testid": 'modal-regime-decision-entree-answer-' + answer.nextId
      },
      on: {
        "click": function($event) {
          _vm.onSelectAnswer(answer.nextId)
        }
      }
    }, [_vm._v("\n                " + _vm._s(answer.label) + "\n            ")])
  }))] : (_vm.isLeaf && _vm.leafNode) ? [_c('div', {
    staticClass: "leaf-result",
    attrs: {
      "data-testid": "modal-regime-decision-entree-result"
    }
  }, [_c('i', {
    staticClass: "ri-checkbox-circle-line"
  }), _vm._v(" "), _c('span', {
    staticClass: "result-heading",
    attrs: {
      "data-testid": "modal-regime-decision-entree-result-heading"
    }
  }, [_vm._v("Résultat trouvé")]), _vm._v(" "), _c('i', {
    staticClass: "ri-arrow-right-line"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-testid": "modal-regime-decision-entree-result-libelle"
    }
  }, [_vm._v(_vm._s(_vm.proposedRegimeLibelle))])])] : _vm._e(), _vm._v(" "), (_vm.footerRegimeDecisionVisible) ? _c('div', {
    staticClass: "dialog-footer-regime-decision",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.currentNode && _vm.currentNode.type === 'question') ? _c('div', {
    staticClass: "footer-bar"
  }, [(!_vm.canGoBack() && !_vm.isManualChoice) ? _c('el-button', {
    attrs: {
      "data-testid": "modal-regime-decision-entree-manual-choice-button"
    },
    on: {
      "click": _vm.manualChoice
    }
  }, [_vm._v("Choix manuel")]) : _c('el-button', {
    attrs: {
      "disabled": !_vm.canGoBack()
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Question précédente")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.onDialogClosed
    }
  }, [_vm._v("Quitter")])], 1) : (_vm.isLeaf && _vm.leafNode) ? _c('div', {
    staticClass: "footer-leaf"
  }, [_c('el-button', {
    attrs: {
      "data-testid": "modal-regime-decision-entree-close-button"
    },
    on: {
      "click": _vm.onDialogClosed
    }
  }, [_vm._v("Fermer")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "data-testid": "modal-regime-decision-entree-apply-button"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("Appliquer")])], 1) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45a16909"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entreeSalarie/modalRegimeDecision/modalRegimeDecisionEntreeSalarie.vue.html
// module id = X/SZ
// module chunks = 2